import { addons } from '@storybook/addons'
import { create } from '@storybook/theming'

import '../node_modules/@hotmart-org-ca/cosmos-tokens/dist/cosmos/base/css/_variables.css';
import './common.css'
import './manager.css'

const cosmosStorybook = create({
  base: 'light',
  brandTitle: 'Cosmos',
  brandUrl: '/',
  brandImage: 'cosmos-logo.svg',

  colorPrimary: '#000000',
  colorSecondary: '#000000',

  appBg: '#FFFFFF',
  appContentBg: '#F7F9FA',
  appBorderColor: '#E5E7EB',
  appBorderRadius: 4,

  fontBase: 'sans-serif',
  fontCode: 'monospace',

  textColor: '#000000',
  textInverseColor: '#FFFFFF',

  barTextColor: '#000000',
  barSelectedColor: '#000000',
  barBg: '#FFFFFF',

  inputBg: '#FFFFFF',
  inputBorder: '#C9CED4',
  inputTextColor: '#000000',
  inputBorderRadius: 4
})

addons.setConfig({
  theme: cosmosStorybook,
  sidebar: {
    showRoots: true
  }
})
